(function () {
  'use strict';
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.vero-color-thumb').forEach(function (btn) {
      btn.addEventListener('click', function () {
        document.querySelectorAll('.vero-color-thumb').forEach(function (b) {
          b.classList.remove('is-selected');
        });
        btn.classList.add('is-selected');
        var label = document.getElementById('vero-color-label');
        if (label) label.textContent = btn.dataset.color;
      });
    });
    document.querySelectorAll('.vero-size').forEach(function (btn) {
      btn.addEventListener('click', function () {
        document.querySelectorAll('.vero-size').forEach(function (b) {
          b.classList.remove('is-selected');
        });
        btn.classList.add('is-selected');
      });
    });
  });
})();
